export const INVALID = 'invalid'
export const NIL = 'nil'
export const STRING = 'string'
export const INT = 'int'
export const UINT = 'uint'
export const FLOAT = 'float'
export const BOOL = 'bool'
export const TIME = 'time'
export const DURATION = 'duration'
export const REGEXP = 'regexp'
export const ARRAY = 'array'
export const OBJECT = 'object'
export const FUNCTION = 'function'
